import { SVGProps } from 'react';

const UserRoundPen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2 21a8 8 0 0 1 10.821-7.487m8.557 3.113a2.124 2.124 0 1 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837c.323-.094.616-.268.854-.506zM15 8A5 5 0 1 1 5 8a5 5 0 0 1 10 0"
    />
  </svg>
);
export default UserRoundPen;
